module.exports = __webpack_public_path__ + "static/mobile_x86_qrcode.3ecc62ed.png";